import { useEffect, useRef } from "react";

/** Calls `tick` every `ms` while `enabled` and the tab is visible; catches up as soon as the tab is shown again. */
export function usePoll(tick: () => void, ms: number, enabled = true): void {
  const tickRef = useRef(tick);
  tickRef.current = tick;

  useEffect(() => {
    if (!enabled) return;
    const id = setInterval(() => { if (!document.hidden) tickRef.current(); }, ms);
    const onVisible = () => { if (!document.hidden) tickRef.current(); };
    document.addEventListener("visibilitychange", onVisible);
    return () => { clearInterval(id); document.removeEventListener("visibilitychange", onVisible); };
  }, [ms, enabled]);
}
